import React, { useState, useEffect } from "react";
import {
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Button,
    IconButton,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Typography,
} from "@material-ui/core";
import { Edit, Delete, Add } from "@material-ui/icons";
import { API } from "../../config";
import Notify from "../../components/customHelpers/Notify";
import Notification from "../../components/customHelpers/Notification";
import Layout from "../../components/layout/Layout";
import Admin from "../../components/auth/Admin";
import { useMediaQuery, useTheme } from "@material-ui/core";
import ConfirmDialog from "../../components/customHelpers/ConfirmDialog";

const RoleManagement = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const { NotifyMessage, notify, setNotify } = Notify();
    const [roles, setRoles] = useState([]);
    const [open, setOpen] = useState(false);
    const [currentRole, setCurrentRole] = useState({ id: null, name: "" });
    const [isEditing, setIsEditing] = useState(false);

    const [confirmDialog, setConfirmDialog] = useState({
        isOpen: false,
        title: "",
        subTitle: "",
    });

    useEffect(() => {
        fetchRoles();
    }, []);

    const fetchRoles = () => {
        fetch(`${API}/roles`)
            .then((res) => res.json())
            .then((data) => {
                setRoles(data.data);
            });
    };

    const handleOpen = (role = { id: null, name: "" }) => {
        setCurrentRole(role);
        setIsEditing(!!role.id);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setCurrentRole({ id: null, name: "" });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const url = isEditing ? `${API}/role/${currentRole.id}` : `${API}/role`;
        const method = isEditing ? "PUT" : "POST";

        fetch(url, {
            method: method,
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ name: currentRole.name }),
        })
            .then((res) => res.json())
            .then((data) => {
                if (data.err) throw new Error(data.err);
                NotifyMessage({ message: data.message, type: "success" });
                fetchRoles();
                handleClose();
            })
            .catch((err) => {
                NotifyMessage({ message: err.message || "Error saving role", type: "error" });
            });
    };

    const onDelete = (id) => {
        setConfirmDialog({ ...confirmDialog, isOpen: false });

        fetch(`${API}/role/${id}`, { method: "DELETE" })
            .then((res) => res.json())
            .then((data) => {
                if (data.err) throw new Error(data.err);
                NotifyMessage({ message: data.message, type: "success" });
                fetchRoles();
            })
            .catch((err) => {
                NotifyMessage({ message: err.message || "Error deleting role", type: "error" });
            });
    };

    return (
        <Layout>
            <Admin>
                <div style={{ padding: isMobile ? 10 : 20 }} className="card">
                    {/* <PageHeader title="Role Management" subTitle="Manage user roles and permissions" icon={<Add />} /> */}
                    <Typography variant="h6" className="page-header">
                        Role Management
                    </Typography>
                    <Button
                        variant="contained"
                        color="primary"
                        startIcon={<Add />}
                        onClick={() => handleOpen()}
                        style={{ marginBottom: 20 }}
                        fullWidth={isMobile}
                    >
                        Create Role
                    </Button>

                    <TableContainer component={Paper}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>ID</TableCell>
                                    <TableCell>Role Name</TableCell>
                                    <TableCell align="right">Actions</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {roles.map((role) => (
                                    <TableRow key={role.id}>
                                        <TableCell>{role.id}</TableCell>
                                        <TableCell>{role.name}</TableCell>
                                        <TableCell align="right">
                                            <IconButton onClick={() => handleOpen(role)}>
                                                <Edit color="primary" />
                                            </IconButton>
                                            <IconButton onClick={() => {
                                                setConfirmDialog({
                                                    isOpen: true,
                                                    title: "Are you sure you want to delete this role?",
                                                    subTitle: "You can't undo this operation",
                                                    onConfirm: () => onDelete(role.id)
                                                })
                                            }}>
                                                <Delete color="secondary" />
                                            </IconButton>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>

                    {/* Upsert Dialog */}
                    <Dialog open={open} onClose={handleClose} fullScreen={isMobile}>
                        <form onSubmit={handleSubmit}>
                            <DialogTitle>{isEditing ? "Edit Role" : "Create Role"}</DialogTitle>
                            <DialogContent>
                                <TextField
                                    autoFocus
                                    margin="dense"
                                    label="Role Name"
                                    fullWidth
                                    value={currentRole.name}
                                    onChange={(e) => setCurrentRole({ ...currentRole, name: e.target.value })}
                                    required
                                />
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={handleClose}>Cancel</Button>
                                <Button type="submit" color="primary">
                                    {isEditing ? "Update" : "Create"}
                                </Button>
                            </DialogActions>
                        </form>
                    </Dialog>

                    <ConfirmDialog confirmDialog={confirmDialog} setConfirmDialog={setConfirmDialog} />

                    <Notification notify={notify} setNotify={setNotify} />
                </div>
            </Admin>
        </Layout>
    );
};

export default RoleManagement;
